(function () {
  var rememberMode = document.documentElement.dataset.localeRememberMode;
  var overrideDurationDays = parseInt(document.documentElement.dataset.localeOverrideDuration, 10) || 365;
  var persistAllowed = false; // default: fail closed to session until consent is verified

  function resolvePersistConsent() {
    if (typeof window.Shopify === 'undefined' || typeof window.Shopify.loadFeatures !== 'function') {
      persistAllowed = true; // no Customer Privacy API on this store -- nothing to gate against
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (
          !window.Shopify.customerPrivacy ||
          typeof window.Shopify.customerPrivacy.currentVisitorConsent !== 'function'
        ) {
          return;
        }
        var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        persistAllowed = consent.preferences === 'yes';
      }
    );
  }

  function setPersistentCookie(value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + overrideDurationDays * 24 * 60 * 60 * 1000);
    document.cookie =
      'locale_manual_override=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax; Secure';
  }

  function setSessionMarker(value) {
    try {
      window.sessionStorage.setItem('locale_manual_override', value);
    } catch (e) {
      // storage unavailable -- nothing more we can do
    }
  }

  function onLocalizationFormSubmit(value) {
    if (rememberMode === 'off') return;
    if (rememberMode === 'persistent' && persistAllowed) {
      setPersistentCookie(value);
      return;
    }
    setSessionMarker(value);
  }

  function maybeRecordOverride(form) {
    if (!form || form.tagName !== 'FORM' || !form.action || form.action.indexOf('/localization') === -1) {
      return;
    }
    var field = form.querySelector('input[name="locale_code"], [name="language_code"]');
    if (!field || !field.value) return;
    // country and language share one form -- ignore country-only submits
    var currentLang = (document.documentElement.lang || '').toLowerCase();
    if (field.value.toLowerCase() === currentLang) return;
    onLocalizationFormSubmit(field.value);
  }

  document.addEventListener(
    'submit',
    function (event) {
      maybeRecordOverride(event.target);
    },
    true
  );

  // form.submit() never fires a 'submit' event -- intercept that path too
  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    try {
      maybeRecordOverride(this);
    } catch (e) {
      // never block the real submission
    }
    return nativeFormSubmit.apply(this, arguments);
  };

  if (rememberMode === 'persistent') {
    resolvePersistConsent();
  }
})();
